/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Menu_MainInputs */

const en_control_menu_main = /** @type {(inputs: Control_Menu_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main`)
};

const zh_control_menu_main = /** @type {(inputs: Control_Menu_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主导航`)
};

/**
* | output |
* | --- |
* | "Main" |
*
* @param {Control_Menu_MainInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_menu_main = /** @type {((inputs?: Control_Menu_MainInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Menu_MainInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_menu_main(inputs)
	return zh_control_menu_main(inputs)
});
export { control_menu_main as "control.menu.main" }